import React from 'react';
import { Box, Typography, Paper, Container ,Divider} from '@mui/material';
import  TimelineComponent  from './TimelineComponent';
import HorizontalTimeline from './htimeline';

import  { useEffect, useState } from 'react';
import { ToggleButtonGroup, ToggleButton, Grid, Button, CircularProgress } from '@mui/material';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import DynamicAnswerSubmit from './DynamicAnswerSubmit';
import CreateSchedule from './CreateSchedule';
import { useParams , useLocation} from 'react-router-dom';
import CenteredAlert from './CenteredAlert';
import {main_url , DARK_BLUE } from  './basefile';
import DocumentList_pt from './DocumentList_pt'
import FloatingbackButton from './Floatbt_backy.jsx';
import FloatinglogoutButton from './Floatbt_logout';
import FileUploader from './FileUploader';
import ParticipantExit from './ParticipantExit.jsx';
import DocumentList_exe from './DocumentList_exe.jsx'
import CustomSnackbar from './CustomSnackbar';

/*
active_projects
: 
[{id: 22, name: "Backbone Test", description: "Test", type: "external", start_date: "2025-08-12",…},…]
contact_person
: 
"ff"
created_at
: 
"2025-07-12T14:03:06.254046Z"
created_by
: 
1
email
: 
"rayonatechnologies@gmail.com"
id
: 
3
mailing_address
: 
"INDIA"
name
: 
"Hari"
note
: 
"NA"
patient_type
: 
"outpatient"
phone
: 
"7397038639"
status
: 
"active"
updated_at
: 
"2025-07-12T14:03:06.254058Z"
updated_by
: 
1
user
: 
1
*/


const PatientDetail = () => {

  //const { ptiid } = useParams();
  const { ptiid, projectid,procode } = useParams();

  const location = useLocation();

  const [patientobj, setPatientobj] = useState(() => location.state?.patiid || null);
  
  //alert(JSON.stringify(patientobj));

  const name = "Alex";
  const Schedule_craeted = true;
  const [ executionId, setExecutionId ] = useState(null);
  
  const [data, setData] = useState(null);       // store fetched data
  const [loading, setLoading] = useState(true); // loading state
  const [showButton, setShowButton] = useState(false); 
  const [showComponent, setShowComponent] = useState(false);
  const  [selected, setSelected] = useState(null);
  const [matchfound, setmatchfound] = useState(false);  

  const [showAttachment, setShowAttachment] = useState(false);
  const [exestatus, setExestatus] = useState('');

  const [snackbarOpen1, setSnackbarOpen1] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [scheduleRefreshKey, setScheduleRefreshKey] = useState(0);



  const showClick = () => {
    setShowAttachment(true);
  };


  const handleSignOff = () => {
    // updated execution status
    // http://3.111.199.207:8000/api/v1/executions/exid
    // patcH
          
    const token = localStorage.getItem('authToken');

    const url = `${main_url}/api/v1/executions/${executionId}/`;

    const payload = {
      completion_date: new Date().toISOString().split('T')[0],
      status: "completed"
    };

    fetch(url, {
      method: 'PATCH',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
      })
      .then((res) => {
        if (!res.ok) throw new Error('Network response was not ok');
        return res.json();
      })
      .then((data) => {
        setSnackbarMessage('Execution complete updated successfully !');
        setSnackbarSeverity('success');
        setSnackbarOpen1(true);
      })
      .catch((err) => {
        alert('Failed to update schedule.');
        
      });

  };

   const handleChange = (_, newValue) => {
    if (newValue !== null) {
      setSelected(newValue);
    }
  };

   const handleClick = () => {
    setShowComponent(false);
  };

  // Load function (simulate API/database)
  const loadInitialData = async () => {
      const token = localStorage.getItem('authToken');
      const targetPatientId = ptiid;
      
      let page = 1;
      const limit = 20;
      let allResults = [];
      let hasMore = true;

     try {

        while (hasMore) {

        const res = await fetch(`${main_url}/api/v1/executions/?page=${page}&limit=${limit}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (!res.ok) {
          throw new Error('Network response was not ok');
        }

        const data = await res.json();
        if (data.results && data.results.length > 0) {
                  allResults = [...allResults, ...data.results];
        }
         let total_p = data.pagination.total_pages;
          let cur_page = data.pagination.current_page;

          // Check if more pages exist
          if (cur_page < total_p) {
              //alert(data.count);
              hasMore = true;
              page = cur_page + 1 ;
          } else {
            // Fallback: stop if no results returned
            hasMore = false;
          }
        }

        //const formatted = Array.isArray(data) ? data : data.results;

        let Matchfound =false;
        let exid = 0;

        for (const item of allResults) {
          if (item.patient.id == targetPatientId && item.project.id == projectid) {
            console.log("Match found!");
            Matchfound = true;
            exid = item.id;
            setExestatus(item.status);
            break; // ✅ break works here
          }
        }

        // alert(Matchfound);
        setmatchfound(Matchfound);

        if(Matchfound == false)
        {
          alert("execution not created yet, so creating now")
        }else{
          setExecutionId(exid);
        }

        } catch (err) {
        console.error("Error fetching executions:", err);
        alert("Error fetching executions:");
         
     } finally {
        setLoading(false);
      }
  };


 // Run on component mount
  useEffect(() => {
    // check any execution created already for this patient
    loadInitialData();
  }, []);


  return (
    // old f0f0f0
    
    <Box sx={{ bgcolor: '#dde7ecff', display:"releative",  alignItems: 'center', }}>
      {/* 🔷 Top Box (banner/header) */}
      <Box 
        sx={{ pt:5,
          height: 150,
         
          bgcolor: DARK_BLUE,
          textAlign: 'center',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
          borderRadius: 0,
        }}
      >
        <Typography variant="h4" fontWeight="bold">
          Participant
        </Typography>
      </Box>

      {/*  Overlapping Box */}
      <Container   sx={{ mt: { xs: -8, md: -6 ,  width:1200,  display:"flex"} }}>
      

<Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        px: { xs: 2, md: 4 },
        py: 4,
        mt:-3,ml:10,
        width:1000
      }}
    >
      <Paper
        elevation={4}
        sx={{
          p: 4,
          width: '100%',
          maxWidth: 1000,
          borderRadius: 3,
          bgcolor: '#ffffff',
          minHeight: { xs: 400, md: 300 },
        }}
      >
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          📄 Participant Profile
        </Typography>
 {/* BASIC DETAILS */}
        <Box sx={{ mt: 3 }}>
          <Typography variant="subtitle1" fontWeight="bold" color="primary" gutterBottom>
            Basic Details
          </Typography>
          <Grid container rowSpacing={2} columnSpacing={3}>
             <Grid item xs={3}>
              <Typography fontWeight={600} color="text.secondary">
                 Id:
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography>{procode + "-"+  String(patientobj.id).padStart(3, "0") }</Typography>
            </Grid>

            <Grid item xs={5}>
              <Typography fontWeight={600} color="text.secondary">
                First Name:
              </Typography>
            </Grid>
            
            <Grid item xs={7}>
              <Typography>{patientobj.first_name}</Typography>
            </Grid>

               <Grid item xs={5}>
              <Typography fontWeight={600} color="text.secondary">
                Middle Name:
              </Typography>
            </Grid>
            
            <Grid item xs={7}>
              <Typography>{patientobj.middle_name}</Typography>
            </Grid>

            <Grid item xs={5}>
              <Typography fontWeight={600} color="text.secondary">
                Last Name:
              </Typography>
            </Grid>
            
            <Grid item xs={7}>
              <Typography>{patientobj.last_name}</Typography>
            </Grid>

             <br></br>
            <Grid item xs={5}>
              <Typography fontWeight={600} color="text.secondary">
                 Type:
              </Typography>
            </Grid>
            <Grid item xs={7}>
              <Typography>{patientobj.type}</Typography>
            </Grid>
          </Grid>
        </Box>

        <Divider sx={{ my: 3 }} />

        {/* CONTACT DETAILS */}
        <Box>
          <Typography variant="subtitle1" fontWeight="bold" color="primary" gutterBottom>
            Contact Details
          </Typography>
          <Grid container spacing={2}>
            

            <Grid item xs={5}>
              <Typography fontWeight={600} color="text.secondary">
                Phone:
              </Typography>
            </Grid>
            <Grid item xs={7}>
              <Typography>{patientobj.phone}</Typography>
            </Grid>

            <Grid item xs={5}>
              <Typography fontWeight={600} color="text.secondary">
                Email:
              </Typography>
            </Grid>
            <Grid item xs={7}>
              <Typography>{patientobj.email}</Typography>
            </Grid>

            <Grid item xs={5}>
              <Typography fontWeight={600} color="text.secondary">
                Address:
              </Typography>
            </Grid>
            <Grid item xs={7}>
              <Typography>{patientobj.mailing_address}</Typography>
            </Grid>


          </Grid>
        </Box>

        <Divider sx={{ my: 3 }} />

        {/* MISCELLANEOUS */}
        <Box>
          <Typography variant="subtitle1" fontWeight="bold" color="primary" gutterBottom>
            Miscellaneous
          </Typography>
          <Grid container spacing={2}>
          <Grid item xs={5}>
              <Typography fontWeight={600} color="text.secondary">
                Contact Person:
              </Typography>
            </Grid>
            <Grid item xs={7}>
              <Typography>{patientobj.contact_person}</Typography>
            </Grid>
          
            <Grid item xs={5} ml={5}>
              <Typography fontWeight={600} color="text.secondary">
                Additional Info:
              </Typography>
            </Grid>
            <Grid item xs={7}>
              <Typography>{patientobj.note || "N/A"}</Typography>
            </Grid>
            {/* Add more misc fields here as needed */}
          </Grid>
          <br></br>
          <br></br>
          <DocumentList_pt obj_id={ptiid} />
        </Box>
      </Paper>
      
    </Box>
   

      </Container>
      <br></br>

          <Box
            sx={{
              backgroundColor: '#ffffff',
              width: 800,
              ml: 7,
              borderRadius: 3,
              border: '2px solid #ccc',
              p: 3,
            }}
          >
            <Typography variant="h5" fontWeight="bold" color="text.secondary" gutterBottom sx={{ mb: 2 }}>
              Your Schedule
            </Typography>
            {loading ? (
              <CircularProgress />
            ) : (
              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <TimelineComponent exeID={executionId} refreshKey={scheduleRefreshKey} />
              </Box>
            )}
          </Box>
      <br></br> <br></br>
             <Box 
              sx={{
                        // Full viewport height
                display: 'flex',
                flexDirection: 'column',       // Stack vertically
                justifyContent: 'center',      // Center vertically
                alignItems: 'left',          // Center horizontally
                gap: 2,                         // Space between title and button
                backgroundColor:'#ffffff',
                width:800,
                ml:55,
                 borderRadius:3,
                 border: '2px solid #ccc',
              }}
            >


      <Typography variant="h5" fontWeight="bold" sx={{ml:5,mt:3}}  color="primary">
        Participant Study Exit
      </Typography>


  <Divider sx={{ mb: 5 , borderBottomWidth: 2, }} />

{exestatus !== 'completed' ?(
<Grid container alignItems="center" spacing={2}>
  <Grid item xs={6}>
    <Typography variant="h6"  sx={{ ml: 6 ,mt:1}}>
      Would you like to add Attachment ?
    </Typography>
  </Grid>
   <Button
      sx={{ mr: 5, width: 100 ,mt:3, backgroundColor:"#605fa5ff"}}
      variant="contained"
      
       onClick={showClick}
    >
      Click
    </Button>
  {showAttachment && <Box ml={0} mt={2} sx={{width:900}}>  <FileUploader obj_id={executionId} catog={3} />  </Box> }

      <br></br>
      <br></br><br></br><br></br>
      <br></br><br></br>
      <Button sx={{ml:25,width:400}}
        variant="contained"
        color="primary"
        onClick={handleSignOff}
      >
        Sign Off
      </Button>
</Grid>

):( 
  //else part 
<>
<Typography variant="h6"  sx={{ ml: 5 ,mt:-3}}>
      This Participant Study already completed 
    </Typography> 
     <br></br>
<DocumentList_exe  obj_id={executionId} />
      
</>
)}
     <br></br>
  </Box>
 <FloatingbackButton />
 

<CustomSnackbar
              open={snackbarOpen1}
              message={snackbarMessage}
              severity={snackbarSeverity}
              autoHideDuration={2000} // 5 seconds
              onClose={() => setSnackbarOpen1(false)}
            />

</Box>


           
                     
  )
};

export default PatientDetail;
